'use strict';

/**
 * On-demand loader for Google reCAPTCHA v3 (score-based bot detection).
 *
 * PRIVACY/CONSENT NOTE (GDPR/CPRA data minimization): this is deliberately NOT
 * invoked at page load. Call it on the shopper's first interaction with a
 * protected form so Google code only runs when the protected action actually
 * starts, and pass the token-generating work as the callback on submit.
 *
 * State lives on window because multiple webpack bundles embed their own copy
 * of this module. It intentionally does NOT gate on window.grecaptcha: the v2
 * loader (components/reCaptcha.js) may have defined it already, but v3
 * execute(siteKey, {action}) requires the api.js?render=<v3key> variant, so
 * this loader tracks its own script request.
 *
 * @param {Function} [callback] - invoked once the v3 script is ready
 */
module.exports = function loadRecaptchaV3(callback) {
    /**
     * Runs a queued callback once the library is fully initialized.
     * @param {Function} cb - callback to run
     */
    function dispatch(cb) {
        if (window.grecaptcha && typeof window.grecaptcha.ready === 'function') {
            window.grecaptcha.ready(cb);
        } else {
            cb();
        }
    }

    if (window.ueRecaptchaV3Ready) {
        if (typeof callback === 'function') {
            dispatch(callback);
        }
        return;
    }

    window.ueRecaptchaV3Queue = window.ueRecaptchaV3Queue || [];
    if (typeof callback === 'function') {
        window.ueRecaptchaV3Queue.push(callback);
    }

    if (window.ueRecaptchaV3Requested) {
        return;
    }
    window.ueRecaptchaV3Requested = true;

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://www.google.com/recaptcha/api.js?render=' + window.SitePreferences.NEW_RECAPTCHA_SITE_KEY;
    script.onload = function () {
        window.ueRecaptchaV3Ready = true;
        var queue = window.ueRecaptchaV3Queue || [];
        window.ueRecaptchaV3Queue = [];
        for (var i = 0; i < queue.length; i += 1) {
            dispatch(queue[i]);
        }
    };
    document.getElementsByTagName('head')[0].appendChild(script);
};
